import { render, staticRenderFns } from "./InventoryListing.vue?vue&type=template&id=5b3ddfb2&scoped=true&lang=pug&"
import script from "./InventoryListing.vue?vue&type=script&lang=js&"
export * from "./InventoryListing.vue?vue&type=script&lang=js&"
import style0 from "./InventoryListing.vue?vue&type=style&index=0&id=5b3ddfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ddfb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VMenu})
